export const EMERY_MESSAGES: Record<string, string> = {
  step1:
    "I negotiate with your carrier on your behalf. I just need your carrier name and policy number to get started.",
  step2:
    "Your carrier will need to verify you're the policyholder. Give me these exactly as they appear on your policy.",
  step3:
    "Carriers often have outdated info about your vehicle, and updating it is one of the fastest ways to lower your rate.",
  step4:
    "Things like your license year, education, and job can unlock discounts your carrier never told you about.",
  step5_yes:
    "Got it, let's add them. Don't worry, for most shared fields you can just tap 'Same as you' and skip ahead.",
  step5_no:
    "Almost there. One last question about your policy.",
  step6:
    "Almost done. The more context you give me, the harder I can push. All fields here are optional.",
  success:
    "You're all set! I'll call your carrier within 1\u20132 business days. Sit back, I've got this. You'll get an email with updates.",
};
